<template>
  <div class="wt2-programmers-filter">
    <ul class="list-unstyled">
      <li>
        <wt-check-box
          :checked="dropdownStateAll"
          :label-right="'dashboardFilter.filterAll' | culture"
          @changed="onToggleAll"
        />
      </li>
      <li v-for="p in dropdownState" :key="p.id">
        <wt-check-box
          v-model="p.selected"
          :label-right="p.label"
          :label-tooltip="p.label"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'storyboard-tab-brands-selector',

  data() {
    const brandsList = this.$store.state.dashboard.storyboardBrands;
    const dropdownState = this.$_initState(brandsList);

    return {
      brandsList,
      dropdownState,
    };
  },

  computed: {
    dropdownStateAll() {
      return this.$_isAllSelected(this.dropdownState);
    },
  },

  watch: {
    dropdownState: {
      handler(value) {
        this.onApply();
      },
      deep: true,
      immediate: false,
    },
  },

  methods: {
    $_initState(brandsList) {
      const rv = _.cloneDeep(brandsList);

      const allSelected = this.$_isAllSelected(rv);
      if (allSelected) {
        _.each(rv, (b) => {
          b.selected = false;
        });
      }

      return rv;
    },

    onToggleAll(value) {
      _.each(this.dropdownState, (b) => {
        b.selected = value;
      });
    },

    onApply() {
      const allSelected = this.$_isAllSelected(this.dropdownState);

      _.each(this.dropdownState, (dds) => {
        const b = _.find(this.brandsList, (b) => b.id === dds.id);
        b.selected = allSelected || dds.selected;
      });

      this.$emit('on-change');
    },

    $_isAllSelected(brandsList) {
      return (
        _.every(brandsList, (b) => !b.selected) ||
        _.every(brandsList, (b) => b.selected)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.wt2-programmers-filter {
  max-width: 214px;
  ul {
    flex-grow: 1;
    overflow: auto;
    padding: 0;
    margin: 0;
  }
  li {
    height: 30px;
  }
}
</style>
